export default __webpack_public_path__ + "static/media/õ©èÕ©éþ¿┐õ╗Â0828 µïÀÞ┤Ø-rgb.70d2096d.jpg";